<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import assessApi from "@/api/assessment";
export default {
  data() {
    return {
      isActive: 0,
      videoinfo: {}, //考试的信息详情
    };
  },
  components: {
    Paperlist: () => import("./components/Page.vue"),
    isedit: () => import("./components/AddTable.vue"), // 添加
    TheEditor: () => import("@/components/progress/Diagram.vue"), // 拦截页面
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Paperlist";
        case 1:
          return "isedit";
        case 2:
          return "TheEditor";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
    // 查看是否有操作考核权限
    async whetherAuthority() {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await assessApi.isOpenSkill(obj);
      if (data.Status == 200) {
        if (data.Data[0].IsOpenSkill == 0) {
          // 未开通
          this.isActive = 2;
        } else {
          // 已开通
          this.isActive = 0;
        }
      } else {
        this.isActive = 2;
        this.$message.error(data.Msg);
      }
    },
  },
  created() {
    this.whetherAuthority();
  },
};
</script>